import { render } from "./specialtychaxun.vue?vue&type=template&id=a94aad1e&scoped=true"
import script from "./specialtychaxun.vue?vue&type=script&lang=js"
export * from "./specialtychaxun.vue?vue&type=script&lang=js"

import "./specialtychaxun.vue?vue&type=style&index=0&id=a94aad1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a94aad1e"

export default script